export default {
    all: { component: () => import('./AllIcon.vue') },
    anchor: { component: () => import('./AnchorIcon.vue') },
    android: { component: () => import('./AndroidIcon.vue') },
    apple: { component: () => import('./AppleIcon.vue') },
    api: { component: () => import('./ApiIcon.vue') },
    archive: { component: () => import('./ArchiveIcon.vue') },
    'arrow-down': { component: () => import('./ArrowDownIcon.vue') },
    'arrow-left': { component: () => import('./ArrowLeftIcon.vue') },
    'arrow-right': { component: () => import('./ArrowRightIcon.vue') },
    'arrow-right-outlined': { component: () => import('./ArrowRightOutlinedIcon.vue') },
    'arrow-up': { component: () => import('./ArrowUpIcon.vue') },
    'arrow-up-down': { component: () => import('./ArrowUpDownIcon.vue') },
    'arrow-with-stick': { component: () => import('./ArrowWithStickIcon.vue') },
    'thumb-up': { component: () => import('./ThumbUpIcon.vue') },
    bells: { component: () => import('./BellsIcon.vue') },
    branches: { component: () => import('./BranchesIcon.vue') },
    blocked: { component: () => import('./BlockedIcon.vue') },
    pencil: { component: () => import('./PencilIcon.vue') },
    trash: { component: () => import('./TrashIcon.vue') },
    'burger-menu': { component: () => import('./BurgerMenuIcon.vue') },
    calendar: { component: () => import('./CalendarIcon.vue') },
    cart: { component: () => import('./CartIcon.vue') },
    'chart-bar': { component: () => import('./ChartBarIcon.vue') },
    chart: { component: () => import('./ChartIcon.vue') },
    'chart-line': { component: () => import('./ChartLineIcon.vue') },
    channel: { component: () => import('./ChannelIcon.vue') },
    'chart-success': { component: () => import('./IconChartSuccess.vue') },
    check: { component: () => import('./CheckIcon.vue') },
    clock: { component: () => import('./ClockIcon.vue') },
    close: { component: () => import('./CloseIcon.vue') },
    'close-chip': { component: () => import('./CloseChipIcon.vue') },
    'close-outlined': { component: () => import('./CloseOutlinedIcon.vue') },
    config: { component: () => import('./ConfigIcon.vue') },
    'credit-card': { component: () => import('./CreditCardIcon.vue') },
    'credit-card-plus': { component: () => import('./CreditCardPlusIcon.vue') },
    money: { component: () => import('./MoneyIcon.vue') },
    'warning-outlined': { component: () => import('./WarningOutlinedIcon.vue') },
    dashboard: { component: () => import('./DashboardIcon.vue') },
    'de-flag': { component: () => import('./DeFlagIcon.vue') },
    dollar: { component: () => import('./DollarIcon.vue') },
    'dollar-outlined': { component: () => import('./DollarOutlinedIcon.vue') },
    download: { component: () => import('./DownloadIcon.vue') },
    earth: { component: () => import('./EarthIcon.vue') },
    'earth-search': { component: () => import('./EarthSearchIcon.vue') },
    'en-flag': { component: () => import('./EnFlagIcon.vue') },
    equalizer: { component: () => import('./EqualizerIcon.vue') },
    'es-flag': { component: () => import('./EsFlagIcon.vue') },
    eye: { component: () => import('./EyeIcon.vue') },
    facebook: { component: () => import('./FacebookIcon.vue') },
    'facebook-outlined': { component: () => import('./FacebookOutlinedIcon.vue') },
    file: { component: () => import('./FileIcon.vue') },
    'full-screen': { component: () => import('./FullScreenIcon.vue') },
    gambling: { component: () => import('./GamblingIcon.vue') },
    google: { component: () => import('./GoogleIcon.vue') },
    'google-authentication': { component: () => import('./GoogleAuthenticationIcon.vue') },
    heart: { component: () => import('./HeartIcon.vue') },
    'human-meeting': { component: () => import('./HumanMeetingIcon.vue') },
    instagram: { component: () => import('./InstagramIcon.vue') },
    'jp-flag': { component: () => import('./JpFlagIcon.vue') },
    lightning: { component: () => import('./LightningIcon.vue') },
    linkedin: { component: () => import('./LinkedinIcon.vue') },
    'linkedin-outlined': { component: () => import('./LinkedinOutlinedIcon.vue') },
    location: { component: () => import('./LocationIcon.vue') },
    magnifier: { component: () => import('./MagnifierIcon.vue') },
    mail: { component: () => import('./MailIcon.vue') },
    message: { component: () => import('./MessageIcon.vue') },
    microphone: { component: () => import('./MicrophoneIcon.vue') },
    mobile: { component: () => import('./MobileIcon.vue') },
    monitor: { component: () => import('./MonitorIcon.vue') },
    'monitor-mobile': { component: () => import('./MonitorMobileIcon.vue') },
    'label-new': { component: () => import('./LabelNewIcon.vue') },
    lamp: { component: () => import('./LampIcon.vue') },
    'blog': { component: () => import('./BlogIcon.vue') },
    people: { component: () => import('./PeopleIcon.vue') },
    pause: { component: () => import('./PauseIcon.vue') },
    'billings': { component: () => import('./BillingsIcon.vue') },
    play: { component: () => import('./PlayIcon.vue') },
    plus: { component: () => import('./PlusIcon.vue') },
    'plus-in-ring': { component: () => import('./PlusInRingIcon.vue') },
    power: { component: () => import('./PowerIcon.vue') },
    information: { component: () => import('./InformationIcon.vue') },
    'question-stroke': { component: () => import('./QuestionStrokeIcon.vue') },
    'radio-box-blank': { component: () => import('./RadioBoxBlankIcon.vue') },
    'radio-box-marked': { component: () => import('./RadioBoxMarkedIcon.vue') },
    'reset-filters': { component: () => import('./ResetFiltersIcon.vue') },
    rtb: { component: () => import('./RtbIcon.vue') },
    'ru-flag': { component: () => import('./RuFlagIcon.vue') },
    skype: { component: () => import('./SkypeIcon.vue') },
    sound: { component: () => import('./SoundIcon.vue') },
    spades: { component: () => import('./SpadesIcon.vue') },
    statistics: { component: () => import('./StatisticsIcon.vue') },
    copy: { component: () => import('./CopyIcon.vue') },
    'task-square': { component: () => import('./TaskSquareIcon.vue') },
    targeting: { component: () => import('./TargetingIcon.vue') },
    telegram: { component: () => import('./TelegramIcon.vue') },
    'telegram-outlined': { component: () => import('./TelegramOutlinedIcon.vue') },
    update: { component: () => import('./UpdateIcon.vue') },
    'user-details': { component: () => import('./UserDetailsIcon.vue') },
    'user-import': { component: () => import('./UserImportIcon.vue') },
    'user-settings': { component: () => import('./UserSettingsIcon.vue') },
    'vk-outlined': { component: () => import('./VkOutlinedIcon.vue') },
    warning: { component: () => import('./WarningIcon.vue') },
    'x-twitter': { component: () => import('./XTwitterIcon.vue') },
    'yin-yang': { component: () => import('./YinYangIcon.vue') },
    youtube: { component: () => import('./YoutubeIcon.vue') },
    infinity: { component: () => import('./InfinityIcon.vue') },
    percent: { component: () => import('./PercentIcon.vue') },
    active: { component: () => import('./ActiveIcon.vue') },
    'pause-2': { component: () => import('./PauseSecondIcon.vue') },
    'archived-2': { component: () => import('./ArchivedSecondIcon.vue') },
    'filters': { component: () => import('./FiltersIcon.vue') },
    'play-outlined': { component: () => import('./PlayOutlinedIcon.vue') },
    created: { component: () => import('./CreatedIcon.vue') },
    creating: { component: () => import('./CreatingIcon.vue') },
    'archived-3': { component: () => import('./ArchivedThirdIcon.vue') },
    star: { component: () => import('./StarIcon.vue') }

}
